import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const ImporteFormGroup = ({
  innerRef,
  iError,
  iTouched,
  fIsSubmitting,
  noIncluyeIgv,
  vCuentaContable,
  vTipoAfectacion,
  vCentroCosto,
  vFlagCentroCosto,
  vCuentaDestino,
  aplicaDestino
}) => {
  const onKeyDown = React.useCallback(
    e => {
      let nextNodeId = 'modal-select-cuentaContable'

      if (vCuentaContable) {
        nextNodeId = 'modal-select-tipoAfectacion'

        if (vTipoAfectacion) {
          nextNodeId = 'modal-select-centroCosto'

          if (vFlagCentroCosto) {
            if (vCentroCosto) {
              if (aplicaDestino) {
                if (vCuentaDestino) {
                  nextNodeId = 'modal-nuevoasiento-agregar-button'
                } else {
                  nextNodeId = 'modal-select-cuentaDestino'
                }
              } else {
                nextNodeId = 'modal-nuevoasiento-agregar-button'
              }
            }
          } else {
            if (aplicaDestino) {
              if (vCuentaDestino) {
                nextNodeId = 'modal-nuevoasiento-agregar-button'
              } else {
                nextNodeId = 'modal-select-cuentaDestino'
              }
            } else {
              nextNodeId = 'modal-nuevoasiento-agregar-button'
            }
          }
        }
      }

      KeyEventUtil.leaveOnEnterOrTab(nextNodeId, e)
    },
    [
      vCuentaContable,
      vTipoAfectacion,
      vFlagCentroCosto,
      vCentroCosto,
      vCuentaDestino,
      aplicaDestino
    ]
  )

  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='modal-input-importe' md={4} />
      <Col md={8}>
        <Field name='noIncluyeIgv'>
          {({ field }) => (
            <Form.Checkbox {...field} id='check-masigv' label='NO INC IGV' checked={noIncluyeIgv} />
          )}
        </Field>
      </Col>
      <Col md={12}>
        <Field name='importe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              ref={innerRef}
              id='modal-input-importe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
